export { default } from './CurrentWaveRating';
